<template>
    <span v-if="inputWrapperConfigs.visible" @keyup="validateOnValueChange ? null : checkInputValue(false)">
        <div :id="input_id" class="wrapper-input" style="position: relative; "> <!--width: fit-content; scasina input del modal in chrome-->

            <!-- embedda input html inserito nel componente chiamante -->
            <slot></slot>
            <!--<span v-if="" id="editField" class="input-group-addon"><div id="editField" :class="$root.icons.edit" style="cursor: pointer;"></div></span> <!--@click="enableEdit('userField')"-->
            <popover-alert v-if="showInvalidEnvironment && invalid" effect="fade" placement="right" 
                :content="invalidMessage" :popoverCondition="toggleInvalidMessage" :showOK="false" :showNO="false"
                :popoverStyle="{ left:'50px', 'max-width': '200px', width: '200px', 'font-size': 'small', height: 'max-content', 'background-color': '#f2dede', 'border-color': '#ebccd1'}" 
                :arrowStyle="{top:'50%'}" :textStyle="{color: '#a94442'}" classes="errorArrow"> 

                <a :id="toggle_id" style="position: absolute;  top: 3px; right: 5px; cursor: pointer;" 
                    :style="aIconStyle" @click="toggleInvalid">
                    <i :class="$root.icons.exclamation" aria-hidden="true" style="color: red"></i>
                </a>
            </popover-alert>
        </div>
            
    </span>
</template>
<script>

import PopoverAlert from "../popoverWrapper/Popover.vue";

    export default {
        props: {
            configs: Object,
            options: {
                type: Object,
                default: function(){
                    return {}
                }
            },
            aIconStyle: {
                type: Object,
                default: function() {
                    return {}
                }
            },
            validation: null,
            label: null,
            value: null,
            validateOnValueChange: false,
            valueProp: null
        },
        mounted: function() {
            // assegnamento iniziale del valore, i successivi cambiamenti della prop saranno gestiti dal watcher opportuno
            var vm = this;
            this.$emit("registerInput", {
                id: this.inputWrapperConfigs.id,
                validateFunction: this.checkInputValue,
                callbackFunction: function(){
                    // se registerInput viene intercettato, significa che l'input fa parte di una form, e i messaggi d'errore non saranno evidenziati fino alla prima submit
                    vm.showInvalidEnvironment = false;
                }
            })
            this.mergeConfigs();
        },
        components: {
            PopoverAlert
        },
        computed: {
            input_id: function(){
                return this.inputWrapperConfigs.id + "-" + this.uuid;
            },
            toggle_id: function(){
                return 'toggle-' + this.input_id;
            }
        },
        methods: {
            mergeConfigs: function(){
                for(var prop in this.configs){
                    this.inputWrapperConfigs[prop] = this.configs[prop];
                }
                var override = this.$Components[this.inputWrapperConfigs.id]
                if(override){
                    for (var prop in override){
                        this.inputWrapperConfigs[prop] = override[prop];
                    }
                }
                this.$nextTick(function(){
                    if(!this.inputWrapperConfigs.editable){
                        $("#"+ this.input_id + " :input").prop("disabled", true);
                    }
                    if(this.inputWrapperConfigs.label){
                        var el = $("#"+ this.input_id + " label")[0]
                        if(el){
                            el.innerHTML = this.$Jed.firstUpperTranslate(this.inputWrapperConfigs.label);
                        }
                    }
                    if(this.inputWrapperConfigs.placeholder){
                        var el = $("#"+ this.input_id + " input")[0]
                        if(el){
                            el.placeholder = this.$Jed.firstUpperTranslate(this.inputWrapperConfigs.placeholder);
                        }
                    }
                })
            },  
            checkInputValue: function(formOrigin){
                var res = {};
                if(this.inputWrapperConfigs.editable){
                    res = this.validate();
                    this.invalid = !res.result;
                } else {
                    this.invalid = false;
                }
                this.invalidMessage = res.message;
                if(!this.invalid){
                    this.toggleInvalidMessage = false;
                }

                if(formOrigin){
                    this.showInvalidEnvironment = true;
                }

                if(this.showInvalidEnvironment && this.invalid){
                    if(!this.toggleInvalidMessage){
                        this.toggleInvalidMessage = true
                        this.skipToggle = true;
                        this.$nextTick(function(){ 
                            var els = $('#'+this.toggle_id);
                            if(els[0]){
                                els[0].click();
                            }
                        })
                    }
                }
                var validateResult = {result: res.result, value: res.result ? this.value : res.message}
                this.$emit("validateResult", validateResult)
                return validateResult;
            },
            validate: function(){
                
                var isvalid = this.$root.validate(this.validation, (this.valueProp && this.value) ? this.value[this.valueProp] : this.value);
                if(isvalid == null){
                    return {result: true};
                } else {
                    return {result: false, message: isvalid[this.validation][0]};
                }            
            },
            toggleInvalid: function(){
                if(!this.skipToggle){
                    this.toggleInvalidMessage = !this.toggleInvalidMessage;
                } 
                this.skipToggle = false;
            },
            create_UUID: function(){
                var dt = new Date().getTime();
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    var r = (dt + Math.random()*16)%16 | 0;
                    dt = Math.floor(dt/16);
                    return (c=='x' ? r :(r&0x3|0x8)).toString(16);
                });
                return uuid;
            }
        },
        data: function(){
            return {
                // devo evidenziare le incorrettezze a video
                showInvalidEnvironment: true,
                invalid: false,
                invalidMessage: '',
                toggleInvalidMessage: false,
                uuid: this.create_UUID(),
                skipToggle: false,
                validator: null,

                inputWrapperConfigs: {
                    id: "default",
                    visible: true,
                    editable: true
                }
            }
        },
        watch: {
            value: function(){
                if(this.validateOnValueChange){
                    this.$nextTick(function(){
                         this.checkInputValue(false);
                    })
                }
            }
        }
    }
</script>
<style scoped>

</style>
<style>
    div.wrapper-input .vdp-datepicker {
        display: inline-block;
    }
    div.wrapper-input .vdp-datepicker input {
        padding: 1px 0px;
        width: auto;
    }
    div.popover.errorArrow {
        z-index: 9998;
    }
    div.popover.errorArrow:hover {
        z-index: 9999;
    }
    div.wrapper-input div.v-select {
        display: inline-block;
        background-color: white;
    }
</style>


// WEBPACK FOOTER //
// src/components/dynamic/inputWrapper/inputWrapper.vue?cbe1b47c